import { ConnectProto } from "@racoon/api";
import { Namespace, useT, type KeysOf } from "@racoon/i18n";
import { enumColors } from "@racoon/lib";
import { cn } from "@racoon/ui";

/** A job's status as a pill in the app-wide status colours. */
export const JobStatusPill = ({
  status,
  className,
}: {
  status: ConnectProto.JobStatus | undefined;
  className?: string;
}) => {
  const t = useT();
  const statusKey =
    `JOB_STATUS_${ConnectProto.JobStatus[status ?? ConnectProto.JobStatus.UNDEFINED]}` as KeysOf<Namespace.Enum>;
  const color = enumColors[statusKey];

  return (
    <span
      className={cn(
        "inline-flex min-w-[110px] items-center justify-center whitespace-nowrap rounded-full px-2 py-1 text-xs",
        color?.bg,
        color?.color,
        color?.borderColor && `${color.borderColor} border`,
        className,
      )}
    >
      {t(Namespace.Enum, statusKey)}
    </span>
  );
};
